var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesStories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H88V88H0z",
    transform: "translate(-444 -2074) translate(444 2074)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6E8188",
    d: "M50.043 2.845L50.043 0 0 0 0 50.043 6.805 50.043 6.805 6.835 50.043 6.835 50.043 2.845",
    transform: "translate(-444 -2074) translate(444 2074) translate(12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6B8B4",
    d: "M56.877 9.651L56.877 6.835 6.805 6.835 6.805 56.877 13.64 56.877 13.64 13.64 56.877 13.64 56.877 9.651",
    transform: "translate(-444 -2074) translate(444 2074) translate(12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EC0DF",
    d: "M13.64 13.64v39.13c13.845-6.6 36.227-6.6 50.043 0V13.64H13.64",
    transform: "translate(-444 -2074) translate(444 2074) translate(12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D481",
    d: "M48.4 23.907c0 2.17-1.79 3.989-3.99 3.989s-3.989-1.819-3.989-3.99c0-2.2 1.79-3.989 3.99-3.989s3.989 1.79 3.989 3.99",
    transform: "translate(-444 -2074) translate(444 2074) translate(12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M46.523 37.517c-.147-.293-.235-.586-.235-.909 0-.939.792-1.73 1.76-1.73.44 0 .85.175 1.173.44.206-1.526 1.526-2.729 3.11-2.729 1.76 0 3.168 1.438 3.168 3.139 0 .205-.03.41-.03.587.147-.03.323-.03.528-.03 1.467 0 2.67 1.174 2.67 2.64 0 1.467-1.203 2.64-2.67 2.64h-9.093c-1.144 0-2.053-.909-2.053-2.053 0-.997.704-1.819 1.672-1.995",
    transform: "translate(-444 -2074) translate(444 2074) translate(12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D7D1",
    d: "M26.547 32.53c-.147-.263-.235-.586-.235-.88 0-.967.792-1.76 1.76-1.76.47 0 .88.206 1.173.47.206-1.555 1.526-2.757 3.139-2.757 1.73 0 3.168 1.437 3.168 3.168 0 .205-.03.381-.059.586.176-.029.352-.058.528-.058 1.467 0 2.67 1.173 2.67 2.669 0 1.437-1.203 2.64-2.67 2.64h-9.064c-1.144 0-2.082-.939-2.082-2.083 0-.997.733-1.818 1.672-1.994",
    transform: "translate(-444 -2074) translate(444 2074) translate(12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M19.595 29.51c-.147-.235-.235-.529-.235-.822 0-.968.792-1.79 1.76-1.79.44 0 .85.177 1.173.47.176-1.555 1.526-2.757 3.139-2.757 1.73 0 3.139 1.437 3.139 3.168 0 .205 0 .381-.059.586.176-.058.352-.088.557-.088 1.467 0 2.64 1.203 2.64 2.699 0 1.467-1.173 2.64-2.64 2.64h-9.093c-1.144 0-2.053-.91-2.053-2.053 0-1.027.733-1.848 1.672-2.054",
    transform: "translate(-444 -2074) translate(444 2074) translate(12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3FA592",
    d: "M13.64 52.77v7.187L24.347 49.28c-3.872.821-7.51 1.965-10.707 3.49M37.224 63.683h7.304l13.23-13.2c-1.878-.558-3.843-1.056-5.867-1.467L37.224 63.683zM44.763 48.077L29.128 63.683H33l15.253-15.224c-1.144-.176-2.317-.294-3.49-.382M63.683 59.165L59.136 63.683 61.783 63.683 63.683 63.683zM48.752 63.683h6.16l8.77-8.771v-2.141c-.88-.411-1.818-.822-2.786-1.203L48.752 63.683zM29.363 48.43c-.059.058-.088.146-.147.205L14.139 63.683h10.794l15.84-15.84c-3.813-.118-7.685.088-11.41.586",
    transform: "translate(-444 -2074) translate(444 2074) translate(12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC0A8",
    d: "M29.363 48.43c-1.702.234-3.374.469-5.016.85L13.64 59.957v3.726h.499l15.077-15.048c.059-.059.088-.147.147-.206M40.773 47.843l-15.84 15.84h4.195l15.635-15.606c-1.32-.117-2.67-.205-3.99-.234M33 63.683h4.224l14.667-14.667c-1.203-.235-2.406-.381-3.638-.557L33 63.683zM57.757 50.483l-13.229 13.2h4.224l2.236-2.23 9.908-9.885c-1.027-.381-2.083-.733-3.139-1.085L48.752 62.31M56.753 63.683L59.136 63.683 63.683 59.165 63.683 54.912 54.912 63.683z",
    transform: "translate(-444 -2074) translate(444 2074) translate(12 12)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesStories);
export default __webpack_public_path__ + "static/media/features-stories.07499290.svg";
export { ForwardRef as ReactComponent };